import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { Container } from '@/components/generals/container'

import { company } from '@/constants/site'

const ROTATE_MS = 6000

// Top ticker: rotates through the phone lines of each city, with quick links on the right.
export const NewsBar: FC = (): ReactNode => {
    const [index, setIndex] = useState(0)
    const [paused, setPaused] = useState(false)
    const lines = company.phones

    useEffect(() => {
        if (lines.length < 2 || paused) return

        const timer = window.setInterval(() => {
            setIndex((current) => (current + 1) % lines.length)
        }, ROTATE_MS)

        return () => window.clearInterval(timer)
    }, [lines.length, paused])

    const active = lines[index % lines.length]

    return (
        <div className='border-b border-current/15'>
            <Container className='flex h-9 items-center justify-between gap-6 font-mono text-[10px] uppercase tracking-[0.14em] sm:text-[11px]'>
                <div
                    className='flex min-w-0 items-center gap-2'
                    onMouseEnter={() => setPaused(true)}
                    onMouseLeave={() => setPaused(false)}
                    onFocus={() => setPaused(true)}
                    onBlur={() => setPaused(false)}
                >
                    <span className='shrink-0 opacity-60'>
                        Atendimento:
                    </span>

                    <a
                        key={active.href}
                        href={active.href}
                        className='min-w-0 truncate transition-opacity animate-in fade-in slide-in-from-bottom-1 duration-500 hover:opacity-70'
                    >
                        {active.city} {active.label}
                    </a>
                </div>

                <div className='hidden shrink-0 items-center gap-3 md:flex'>
                    <a
                        href={company.whatsappUrl}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='transition-opacity hover:opacity-70'
                    >
                        WhatsApp
                    </a>

                    <span aria-hidden='true' className='opacity-40'>
                        |
                    </span>

                    <a
                        href={company.simulationUrl}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='transition-opacity hover:opacity-70'
                    >
                        Faça uma simulação
                    </a>
                </div>
            </Container>
        </div>
    )
}
